import React , {useState, useEffect} from 'react';
import './Packages.css';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { getDocs , collection , db  } from '../firebase';
import Aos from 'aos';
import "aos/dist/aos.css";
import HeroSearch from '../components/HeroSearch';
import SideFooter from '../components/SideFooter';



const Packages = () => {

  const [ packagesArray , setPackagesArray ] = useState([]);

  useEffect(  () => {

    const getPackagesData = async () => { 
      const querySnapshot = await getDocs(collection(db, "packages"));
      const packagesDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setPackagesArray(packagesDataArray);
     
    }
    getPackagesData();
  } , []);

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);

  


  return (
    <div className="main_homepage" >

    
    <NavbarHome />

    <HeroSearch />

    <div className="section most_features_section container-sm">

    <div className="d-flex-c" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline">   اختر رحلتك الجاية  </h1>
</div>

    <div className="grid_packages mt-5">

    {packagesArray && packagesArray.map(( { id , status , image , name , stars , description } ) => (

    
    <div class="product" data-aos-duration="390" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" >
  <span class={`product__price ${status === 'most_people' && 'bg_purple'} ${status === 'most_popular' && 'bg_green'} ${status === 'new' && 'bg_yellow'}`}> 
      {status === 'most_people' && 'الأكثر شعبية'}
      {status === 'most_popular' && 'الأكثر مبيعا'}
      {status === 'new' && 'جديد'}
     </span>
     <Link to={`/package/${id}`} >
  <img class="product__image" src={image} />
  </Link>
  <h1 class="product__title">  {name} </h1>
  <hr />

      <div className="d-flex-c">
      <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
        <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
        <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
        <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
        <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
      </div>

  <p className='main_para mt-1' >
   {description.substring(0 , 125)}
  </p>

  <Link to={`/package/${id}`} >
  <button className="btn_category hover_package w-100 mt-1"  >     تصفح البكج </button>
  </Link>

</div>
 

    ))}


   

    </div>

    </div>

    <SideFooter />
    
    <Footer />
    </div>
  )
}

export default Packages